import React, { ErrorInfo, Fragment } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Message } from "semantic-ui-react";

interface IErrorProps extends WithTranslation {
    rawErrorMessage?: boolean;
}


interface IErrorState {
    hasError: boolean;
    error: Error | null;
    errorMessageVisible: boolean;
}

class RouteErrorBoundary extends React.Component<IErrorProps, IErrorState> {
    constructor(props: IErrorProps) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorMessageVisible: false
        }
    }

    static getDerivedStateFromError(error: Error): IErrorState {
        return {
            hasError: true,
            error: error,
            errorMessageVisible: false
        }
    }

    componentDidCatch(error: Error, logInfo: ErrorInfo) {
        console.error(logInfo);
        console.error(error);
    }


    toggleErrorMessage = () => {
        this.setState((prev) => ({
            errorMessageVisible: !prev.errorMessageVisible
        }))
    }

    render() {
        const { t, rawErrorMessage = false } = this.props;

        if (this.state.hasError) {
            return (
                <Message negative>
                    <Message.Header>{t("Sovelluksessa tapahtui odottamaton virhe!")}</Message.Header>
                    <p>{t("Yritä päivittää sivu, tai poistaa sivuston selaustiedot")}</p>

                    {rawErrorMessage ? (
                        <Fragment>
                            <p style={{ cursor: "pointer" }} onClick={this.toggleErrorMessage}> Näytä virheviesti </p>
                            {this.state.errorMessageVisible ?
                                <pre style={{ whiteSpace: "pre-wrap" }}> {this.state.error?.stack?.toString()} </pre>
                                : null}
                        </Fragment>
                    ) : null}

                </Message>
            );
        }

        return this.props.children;
    }
}

export default withTranslation()(RouteErrorBoundary);